import ButtonTypes from './buttonTypes';

const coOrderStatus = {
  NEW: 'New',
  READY_ASB: 'Ready asb',
  OUT_OF_STOCK: 'Out of stock',
  OUT_OF_RESERVE: 'Out of reserve',
  PART_BOX: 'Part box',
  PICKED: 'Picked',
  PACK_BOX: 'Pack box',
  SHIPPED: 'Shipped',
  PACKED: 'Packed',
  ARCHIVE: 'Archive',
  CANCEL: 'Cancel',
  RETURN: 'Return',
  RESALE: 'Resale',
  HOLD: 'Hold',
};

export const coOrderStatusInfo = {
  [coOrderStatus.NEW]: {
    title: 'New',
    state: ButtonTypes.WARNING
  },
  [coOrderStatus.READY_ASB]: {
    title: 'Ready asb',
    state: ButtonTypes.LIGHT_SUCCESS
  },
  [coOrderStatus.OUT_OF_STOCK]: {
    title: 'Out of stock',
    state: ButtonTypes.LIGHT_DANGER
  },
  [coOrderStatus.OUT_OF_RESERVE]: {
    title: 'Out of reserve',
    state: ButtonTypes.LIGHT_INFO
  },
  [coOrderStatus.PART_BOX]: {
    title: 'Part box',
    state: ButtonTypes.LIGHT
  },
  [coOrderStatus.PICKED]: {
    title: 'Picked',
    state: ButtonTypes.LIGHT_INFO
  },
  [coOrderStatus.PACK_BOX]: {
    title: 'Pack box',
    state: ButtonTypes.LIGHT
  },
  [coOrderStatus.SHIPPED]: {
    title: 'Shipped',
    state: ButtonTypes.SUCCESS
  },
  [coOrderStatus.PACKED]: {
    title: 'Packed',
    state: ButtonTypes.SECONDARY
  },
  [coOrderStatus.ARCHIVE]: {
    title: 'Archive',
    state: ButtonTypes.WARNING
  },
  [coOrderStatus.CANCEL]: {
    title: 'Cancel',
    state: ButtonTypes.DARK
  },
  [coOrderStatus.RETURN]: {
    title: 'Return',
    state: ButtonTypes.DARK
  },
  [coOrderStatus.RESALE]: {
    title: 'Resale',
    state: ButtonTypes.DARK
  },
  [coOrderStatus.HOLD]: {
    title: 'Hold',
    state: ButtonTypes.DARK
  },
};

export const coOrderStatusList = [
  { label: coOrderStatus.NEW, value: coOrderStatus.NEW },
  { label: coOrderStatus.READY_ASB, value: coOrderStatus.READY_ASB },
  { label: coOrderStatus.OUT_OF_STOCK, value: coOrderStatus.OUT_OF_STOCK },
  { label: coOrderStatus.OUT_OF_RESERVE, value: coOrderStatus.OUT_OF_RESERVE },
  { label: coOrderStatus.PART_BOX, value: coOrderStatus.PART_BOX },
  { label: coOrderStatus.PICKED, value: coOrderStatus.PICKED },
  { label: coOrderStatus.PACK_BOX, value: coOrderStatus.PACK_BOX },
  { label: coOrderStatus.SHIPPED, value: coOrderStatus.SHIPPED },
  { label: coOrderStatus.PACKED, value: coOrderStatus.PACKED },
  { label: coOrderStatus.ARCHIVE, value: coOrderStatus.ARCHIVE },
  { label: coOrderStatus.CANCEL, value: coOrderStatus.CANCEL },
  { label: coOrderStatus.RETURN, value: coOrderStatus.RETURN },
  { label: coOrderStatus.RESALE, value: coOrderStatus.RESALE },
  { label: coOrderStatus.HOLD, value: coOrderStatus.HOLD },
];

export default coOrderStatus;
